import { useEffect, useState } from 'react';

interface ProgressBarProps {
  value: number;
  maxValue: number;
  height?: number;
  color?: string;
}

export const ProgressBar = ({ value, maxValue, height = 10, color }: ProgressBarProps) => {
  const [percentage, setPercentage] = useState(0);
  const [displayedColor, setDisplayedColor] = useState('#ccc');

  useEffect(() => {
    // Animate value
    const timeout = setTimeout(() => {
      if (value > 0) {
        setPercentage(Math.round((value / maxValue) * 100));
        if (color) setDisplayedColor(color);
      }
    }, 100);

    // Clean up the timeout
    return () => clearTimeout(timeout);
  }, [value, maxValue, color]);

  return (
    <div
      className="progress-bar-container"
      style={{ height: `${height}px`, borderRadius: `${height}px` }}
    >
      <div
        className="progress"
        style={{
          width: `${percentage}%`,
          minWidth: `${height}px`,
          backgroundColor: displayedColor,
          borderRadius: `${height}px`,
        }}
      ></div>
    </div>
  );
};
